import { FreeServicesParcelSearchFormComponent } from './fsp-parcel-search-form.component';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface';
import { FilterOperator } from '@progress/kendo-data-query/dist/npm/filtering/operators.enum';
import {
  Community,
  District,
} from '../../../gk-dynamic-form/services/cached/cached.model';
import { AnyGeometryObject } from '../../../gk-map/models';
import { GridActionButtonsConfig } from '../../../gk-kendo';
import {
  iwIconCheckmark,
  iwIconCross,
} from '../../../assets/css/ewid-svg/svg-icons';

export enum FreeServicesParcelSearchFormControlName {
  Community = 'community',
  District = 'district',
  Address = 'address',
  Owner = 'owner',
  MainNumber = 'mainNumber',
  SubNumber = 'subNumber',
  Pesel = 'pesel',
  RegisterUnit = 'registerUnit',
}
export class FspParcelSearchFormModel {
  constructor(
    public community: Community,
    public district: District,
    public address: string,
    public owner: string,
    public mainNumber: string,
    public subNumber: string,
    public pesel: string,
    public registerUnit: string,
  ) {}

  static getEmptyModel(): FspParcelSearchFormModel {
    return new this(null, null, null, null, null, null, null, null);
  }

  static fromAppToApi(
    data: FspParcelSearchFormModel,
    uuid: string,
    geom?: AnyGeometryObject,
  ): CompositeFilterDescriptor {
    return {
      logic: 'and',
      filters: [
        {
          field: FreeServicesParcelSearchApiFields.Uuid,
          operator: 'eq',
          value: uuid,
        },
        {
          field: FreeServicesParcelSearchApiFields.Community,
          operator: FilterOperator.EqualTo,
          value: data.community?.id,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.District,
          operator: FilterOperator.EqualTo,
          value: data.district?.id,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.Address,
          operator: FilterOperator.Contains,
          value: data.address,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.Owner,
          operator: FilterOperator.Contains,
          value: data.owner,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.MainNumber,
          operator: FilterOperator.EqualTo,
          value: data.mainNumber,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.SubNumber,
          operator: FilterOperator.EqualTo,
          value: data.subNumber,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.Pesel,
          operator: FilterOperator.EqualTo,
          value: data.pesel,
          ignoreCase: true,
        },
        {
          field: FreeServicesParcelSearchApiFields.RegisterUnit,
          operator: FilterOperator.EqualTo,
          value: data.registerUnit,
          ignoreCase: true,
        },
        ...(geom
          ? [
              {
                field: FreeServicesParcelSearchApiFields.Geom,
                operator: 'Intersects',
                value: geom.geom,
              },
            ]
          : []),
      ].filter(
        (element) => element.value !== undefined && element.value !== null,
      ),
    };
  }
}

export enum FreeServicesParcelSearchApiFields {
  Community = 'GminaId',
  District = 'ObrebId',
  Address = 'Adres',
  Owner = 'Wladajacy',
  MainNumber = 'NrL',
  SubNumber = 'NrM',
  Pesel = 'WladajacyPesel',
  RegisterUnit = 'JednostkaRejestrowa',
  Uuid = 'ZamowUuid',
  Geom = 'Geom',
}

export const freeServicesParcelSearchFormModel =
  FspParcelSearchFormModel.getEmptyModel();

export const freeServicesParcelSearchFormActionButtonsConfig: GridActionButtonsConfig =
  {
    actionsLayout: 'end',
    buttons: [
      {
        text: 'CLEAR_FILTER',
        iconClass: 'fa fa-eraser',
        click: () => FreeServicesParcelSearchFormComponent.prototype.clearForm,
      },
      {
        text: 'APPLY_FILTER',
        type: 'submit',
        svgIcon: iwIconCheckmark,
        className: 'svg-icon-color-info',
      },
      {
        text: 'DISMISS',
        svgIcon: iwIconCross,
        className: 'svg-icon-red',
        click: () => FreeServicesParcelSearchFormComponent.prototype.onCancel,
      },
    ],
  };
